import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Client } from '../../core/models/client.model';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router'; // Importa RouterModule

@Component({
  selector: 'app-client-detail',
  templateUrl: './client-detail.component.html',
  styleUrls: ['./client-detail.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule], // Agrega RouterModule
})
export class ClientDetailComponent implements OnInit {
  @Input() client: Client | null = null; // Cliente recibido como entrada
  @Output() closeDetail = new EventEmitter<void>(); // Emite evento para cerrar el detalle

  constructor() {}

  ngOnInit(): void {}

  close() {
    this.closeDetail.emit(); // Emite el evento de cerrar
  }
}
